import { Header } from "./Header";
import { Wrapper } from "./Wrapper";
import { MenuList } from "./MenuList";
import { DrawerIcon } from "./DrawerIcon";
import { IndexBlock } from "./IndexBlock";
import { TitleBlock } from "./TitleBlock";
import { ContentBody } from "./ContentBody";
import { ContentBlock } from "./ContentBlock";
import { ContentTitle } from "./ContentTitle";
import { ContentFooter } from "./ContentFooter";
import { CompleteButton } from "./CompleteButton";
import { ContentReadArea } from "./ContentReadArea";
import { MobileChapterMenu } from "./MobileChapterMenu";
import { DesignSectionMenu } from "./DesignSectionMenu";
import { ContentComponents } from "./ContentComponents";
import { NextSectionButton } from "./NextSectionButton";
import { EndSimulationBanner } from "./EndSimulationBanner";
import { EndSimulationButtons } from "./EndSimulationButtons";
import { DownloadReportButton } from "./DownloadReportButton";
import { EndSimulationBannerText } from "./EndSimulationBannerText";
import { DesignChapterContentBlock } from "./DesignChapterContentBlock";

export const Notebook = {
  Header,
  Wrapper,
  MenuList,
  DrawerIcon,
  IndexBlock,
  TitleBlock,
  ContentBody,
  ContentBlock,
  ContentTitle,
  ContentFooter,
  CompleteButton,
  ContentReadArea,
  MobileChapterMenu,
  DesignSectionMenu,
  ContentComponents,
  NextSectionButton,
  EndSimulationBanner,
  EndSimulationButtons,
  DownloadReportButton,
  EndSimulationBannerText,
  DesignChapterContentBlock,
};
